import { render, staticRenderFns } from "./view-vessel-assessment.vue?vue&type=template&id=af9214cc&scoped=true"
import script from "./view-vessel-assessment.vue?vue&type=script&lang=js"
export * from "./view-vessel-assessment.vue?vue&type=script&lang=js"
import style0 from "./view-vessel-assessment.vue?vue&type=style&index=0&id=af9214cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9214cc",
  null
  
)

export default component.exports